import CitySEOHead from "@/components/feature/CitySEOHead";
import EdenPrairieHeroSection from "./components/HeroSection";
import EdenPrairieStickyNav from "./components/StickyNav";
import EdenPrairieProcessingTimeSection from "./components/ProcessingTimeSection";
import EdenPrairieServicesSection from "./components/ServicesSection";
import EdenPrairieLocalAreaSection from "./components/LocalAreaSection";
import EdenPrairieTravelTimingSection from "./components/TravelTimingSection";
import EdenPrairieDestinationsSection from "./components/DestinationsSection";
import EdenPrairieTestimonialsSection from "./components/TestimonialsSection";
import EdenPrairieAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import EdenPrairieComparisonSection from "./components/ComparisonSection";
import EdenPrairieMistakesSection from "./components/MistakesSection";
import EdenPrairieHowItWorksSection from "./components/HowItWorksSection";
import EdenPrairieFAQSection from "./components/FAQSection";
import EdenPrairieHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import EdenPrairieFinalCTA from "./components/FinalCTA";
import { faqs } from "./components/FAQSection";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function EdenPrairiePage() {
  return (
    <>
      <CitySEOHead
        city="Eden Prairie"
        state="Minnesota"
        stateAbbr="MN"
        route="/cities/eden-prairie"
        title="Emergency Passport Eden Prairie, MN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Eden Prairie, MN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving MTS Systems, Starkey, CHS employees, and southwest metro families."
        geoPlacename="Eden Prairie, Minnesota"
        geoPosition="44.8547;-93.4708"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
        keywords="expedited passport Eden Prairie MN, emergency passport Eden Prairie, passport renewal southwest metro Hennepin County"
      />
      <div className="font-sans">
        <EdenPrairieHeroSection />
        <EdenPrairieStickyNav />
        <EdenPrairieProcessingTimeSection />
        <EdenPrairieServicesSection />
        <EdenPrairieLocalAreaSection />
        <EdenPrairieTravelTimingSection />
        <EdenPrairieDestinationsSection />
        <EdenPrairieTestimonialsSection />
        <EdenPrairieAcceptanceFacilitiesSection />
        <EdenPrairieComparisonSection />
        <EdenPrairieMistakesSection />
        <EdenPrairieHowItWorksSection />
        <EdenPrairieFAQSection />
        <EdenPrairieHelpfulResourcesSection />
        <EdenPrairieFinalCTA />
      </div>
    </>
  );
}